import React from 'react';
import { NavLink } from 'react-router-dom';

const filters = [
    { label: "Defence", filter: ".cat-1" },
    { label: "Concrete", filter: ".cat-2" },
    { label: "Cocentrator", filter: ".cat-3" },
    { label: "Solar Proudcts", filter: ".cat-4" },
    { label: "Bio degradable", filter: ".cat-5" },
    { label: "Heavy Duty Products", filter: ".cat-6" },
    { label: "Range of Paints", filter: ".cat-7" },
    { label: "Fuel Enhance", filter: ".cat-8" },
    { label: "Bomb Sheels", filter: ".cat-9" }     
];

const projects = [
    // {
    //     image: require('./../../images/projects/portrait/pic1.jpg'),
    //     title: 'Firing Range Container',
    //     address: '',
    //     filter: 'cat-1'
    // },
    {
        image: require('./../../images/projects/portrait/pic9.jpg'),
        title: 'Morcha',
        address: '',
        filter: 'cat-1',
        link: 'morcha'
    },
    {
        image: require('./../../images/projects/portrait/pic2.jpg'),
        title: 'Green CO2 Concrete',
        address: '',
        filter: 'cat-2',
        link: 'green-co2-concrete'
    },
    {
        image: require('./../../images/projects/portrait/pic3.jpg'),
        title: 'Molecular Hydrogen Inhaler',
        address: '',
        filter: 'cat-3',
        link: 'molecular-hydrogen-inhaler'
    },
    {
        image: require('./../../images/projects/portrait/pic4.jpg'),
        title: 'Solar Dryer',
        address: '',
        filter: 'cat-4',
        link: 'solar-dryer'
    },
    {
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'Bio-Degradable Plastic',
        address: '',
        filter: 'cat-5',
        link: 'bio-degradable-plastic'
    },
    {
        image: require('./../../images/projects/portrait/pic6.jpg'),
        title: 'Rolltech Coupler',
        address: '',
        filter: 'cat-6',
        link: 'rolltech-coupler'
    },
    {
        image: require('./../../images/projects/portrait/pic7.jpg'),
        title: 'Lock seal ',
        address: '',
        filter: 'cat-7',
        link: 'lock-seal'
    },
    {
        image: require('./../../images/projects/portrait/pic8.jpg'),
        title: 'Fuel Additive',
        address: '',
        filter: 'cat-8',
        link: 'fuel-additive'
    },
    {
        image: require('./../../images/projects/portrait/pic8.jpg'),
        title: 'Planning Process and Projection 155 MM and 107 MM Bourrelet',
        address: '',
        filter: 'cat-9',
        link: 'bomb-sheet-1'
    }
]

var bgimg1 = require('./../../images/background/cross-line2.png');
var bgimg2 = require('./../../images/background/cross-line.png');

class Projects2 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        return (
            <>
                <div className="section-full  mobile-page-padding bg-white  p-t80 p-b80">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                    <h3 className="sep-line-one">Our Projects</h3>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* Filter Nav START */}
                        <div className="filter-wrap p-b30 text-center">
                            <ul className="filter-navigation masonry-filter clearfix">
                                <li className="active"><NavLink to={"#"} className="btn from-top" data-filter="*" data-hover="All">All</NavLink></li>
                                {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} className="btn from-top" data-filter={item.filter} >{item.label}</NavLink></li>
                                ))}
                            </ul>
                        </div>
                        {/* Filter Nav END */}
                        {/* GALLERY CONTENT START */}
                        <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
                            {projects.map((item, index) => (
                                <div key={index} className={`${item.filter} masonry-item col-lg-4 col-md-6 col-sm-12 m-b30`}>
                                    <div className="sx-box image-hover-block">
                                        <div className="sx-thum-bx">
                                            <img src={item.image} alt="" />
                                        </div>
                                        <div className="sx-info  p-t20 text-white">
                                            <h4 className="sx-tilte"><NavLink to={`/project-detail1/${item.link}`}>{item.title}</NavLink></h4>
                                            <p className="m-b0">{item.address}</p>
                                        </div>
                                        <a className="mfp-link" href={item.image}>
                                            <i className="fa fa-arrows-alt" />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </ul>
                        {/* GALLERY CONTENT END */}
                        <div className="text-center load-more-btn-outer" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                            <button className="site-button-secondry btn-half"><span>Load More</span></button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Projects2;